<template>
  <div>
    <vs-alert
      color="danger"
      title="航海履歴が見つかりません"
      :active.sync="hasError"
    >
    </vs-alert>
    <vx-card v-if="!hasError" class="overlay-card overflow-hidden">
      <div slot="no-body">
        <!-- Map -->
        <div id="vessel-position-map">
          <vessel-voyage-history-map
            v-if="voyageHistoryDateTime"
            :vessel_id="voyageHistoryDateTime.vesselId"
            :vessel_name="vesselName"
            :start_time="voyageHistoryDateTime.startTimeUtc"
            :end_time="voyageHistoryDateTime.endTimeUtc"
            class="responsive card-img-top"
            @onClickPrev="onClickPrev"
            @onClickNext="onClickNext"
          ></vessel-voyage-history-map>
        </div>
      </div>
      <!-- カメラ -->
      <div
        id="vessel-position-live-camera-area"
        class="mapboxgl-ctrl-top-right"
      >
        <div class="mapboxgl-ctrl">
          <!-- ヒストリーカメラ -->
          <vs-row v-if="voyageHistoryDateTime" vs-align="flex-start">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="cameraVsw"
            >
              <vx-card class="overflow-hidden live-camera-card">
                <template slot="no-body">
                  <div
                    :key="index"
                    v-for="(camera, index) in historyCamerasRow1"
                  >
                    <vessel-voyage-history-camera
                      :camera="camera"
                      :startTimeUtc="voyageHistoryDateTime.startTimeUtc"
                      :endTimeUtc="voyageHistoryDateTime.endTimeUtc"
                    ></vessel-voyage-history-camera>
                  </div>
                </template>
              </vx-card>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="cameraVsw"
            >
              <vx-card class="overflow-hidden live-camera-card">
                <template slot="no-body">
                  <div
                    :key="index"
                    v-for="(camera, index) in historyCamerasRow2"
                  >
                    <vessel-voyage-history-camera
                      :camera="camera"
                      :startTimeUtc="voyageHistoryDateTime.startTimeUtc"
                      :endTimeUtc="voyageHistoryDateTime.endTimeUtc"
                    ></vessel-voyage-history-camera>
                  </div>
                </template>
              </vx-card>
            </vs-col>
          </vs-row>
        </div>
      </div>
      <div id="timeline-controller-container" class="mt-2">
        <timeline-controller
          v-if="vessel"
          :vesselId="vessel.id"
          :startTimeUtc="startTimeUtc"
          :endTimeUtc="endTimeUtc"
          :startTimeLocal="startTimeUtc"
          :endTimeLocal="endTimeUtc"
          :enableTime="enableTime"
          :timeLabel="timeLabel"
          ref="timeLineController"
        />
      </div>
    </vx-card>
  </div>
</template>

<script>
import "mapbox-gl/dist/mapbox-gl.css";
import { createNamespacedHelpers } from "vuex";
import { DateUtil } from "@/utils";

// components
import TimelineController from "./components/TimeLineControl";
import VesselVoyageHistoryMap from "@/views/enterprise/management/vessels/vessel-view/components/cardVesselPosition/components/VesselVoyageHistoryMap";
import VesselVoyageHistoryCamera from "@/views/enterprise/management/vessels/vessel-view/components/cardVesselPosition/components/VesselVoyageHistoryCamera";

// Store
const {
  mapActions: mapActionsOfVesselView,
  mapState: mapStateOfVesselView
} = createNamespacedHelpers("enterpriseVesselView");

export default {
  name: "VesselPosition",
  components: {
    VesselVoyageHistoryMap,
    VesselVoyageHistoryCamera,
    TimelineController
  },
  data() {
    return {
      hasError: false,
      vessel: null,
      startTimeUtc: null,
      endTimeUtc: null,
      startTimeLocal: null,
      endTimeLocal: null,
      enableTime: null,
      enableTo: null,
      timeLabel: "12",
      initialized: false,
      cameras: null,
      cameraVsw: "12",
      subscribe: null,
      historyCamerasRow1: [],
      historyCamerasRow2: []
    };
  },
  computed: {
    ...mapStateOfVesselView({
      mode: state => state.mode,
      voyageHistoryDateTime: state => state.voyageHistoryDateTime
    }),

    vesselName() {
      return this.vessel.name_ja ? this.vessel.name_ja : this.vessel.name;
    }
  },
  methods: {
    ...mapActionsOfVesselView([
      "setVoyageHistoryDateTime",
      "fetchCameras",
      "resetEnterpriseVesselViewState"
    ]),

    async setHistoryCameras() {
      let cameras = await this.fetchCameras(this.vesselId);
      switch (cameras.length) {
        case 1:
          this.historyCamerasRow1 = cameras;
          break;
        case 2:
          this.historyCamerasRow1 = cameras;
          break;
        case 3:
          this.cameraVsw = 6;
          this.historyCamerasRow1.push(cameras[0]);
          this.historyCamerasRow1.push(cameras[1]);
          this.historyCamerasRow2.push(cameras[2]);
          break;
        case 4:
          this.cameraVsw = 6;
          this.historyCamerasRow1.push(cameras[0]);
          this.historyCamerasRow1.push(cameras[1]);
          this.historyCamerasRow2.push(cameras[2]);
          this.historyCamerasRow2.push(cameras[3]);
          break;
      }
    },

    rounding30min(target) {
      let res;
      let mm = Number(target.split(":")[1]);
      if (mm >= 30) {
        res = `${target.split(":")[0]}:30:00`;
      } else {
        res = `${target.split(":")[0]}:00:00`;
      }
      return res;
    },

    rounding30minForEnd(target) {
      let res;
      let hh = Number(target.split(":")[0]);
      let mm = Number(target.split(":")[1]);
      if (mm <= 30) {
        res = `${hh}:30:00`;
      } else {
        res = `${hh + 1}:00:00`;
      }
      return res;
    },

    cleanup() {
      this.resetEnterpriseVesselViewState();
    },
    onClickPrev() {
      this.$refs.timeLineController.onClickPrev();
    },
    onClickNext() {
      this.$refs.timeLineController.onClickNext();
    },
  },
  async mounted() {
    if (!this.$route.params.startUtc) {
      this.hasError = true;
    }
    if (this.$route.params.fromPicker) {
      this.startTimeUtc = this.$route.params.startUtc;
      this.endTimeUtc = this.$route.params.endUtc;
      this.startLocal = this.$route.params.startLocal;
      this.endLocal = this.$route.params.endLocal;
      this.timeLabel = this.$route.params.timeLabel;
      this.enableTime = {
        fromLocal: this.$route.params.startLocal,
        toLocal: this.$route.params.endLocal
      };
    } else {
      let targetDayLocal = DateUtil.toMomentObj(
        this.$route.params.startUtc
      ).format("YYYY-MM-DD");

      let startTimeLocal = DateUtil.toMomentObj(
        this.$route.params.startUtc
      ).format("HH:mm:ss");

      let startLocal = `${targetDayLocal}T${DateUtil.rounding10min(
        startTimeLocal
      )}`;

      let endTimeLocal = DateUtil.toMomentObj(this.$route.params.endUtc).format(
        "HH:mm:ss"
      );

      let endLocal = `${targetDayLocal}T${DateUtil.rounding10min(
        endTimeLocal
      )}`;

      let startUtc = DateUtil.toMomentObj(startLocal)
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss");
      let endUtc = DateUtil.addTime(startUtc, 10, "m").format(
        "YYYY-MM-DDTHH:mm:ss"
      );

      let timeLabelStart = DateUtil.toMomentObj(this.$route.params.startUtc).format("YYYY年MM月DD日 HH:mm:ss")
      let timeLabelEnd = DateUtil.toMomentObj(this.$route.params.endUtc).format("HH:mm:ss")
      this.timeLabel  = `${timeLabelStart} - ${timeLabelEnd}`;
      this.startTimeUtc = `${startUtc}.000Z`;
      this.endTimeUtc = `${endUtc}.000Z`;
      this.startLocal = `${startLocal}.000Z`;
      this.endLocal = `${endLocal}.000Z`;
      this.enableTime = {
        fromLocal: `${startLocal}.000Z`,
        toLocal: `${endLocal}.000Z`
      };
    }

    this.vessel = this.$route.params.vessel;
    let payload = {
      vesselId: this.vessel.id,
      startTimeUtc: this.startTimeUtc,
      endTimeUtc: this.endTimeUtc
    };
    await this.setVoyageHistoryDateTime(payload);
  },
  beforeDestroy() {
    this.cleanup();
  }
};
</script>

<style lang="scss">
.mapboxgl-ctrl-attrib-inner {
  display: none !important;
}
.mapboxgl-ctrl-bottom-right {
  display: block !important;
}
</style>

<style lang="scss">
#vessel-position-map {
  height: 580px;
  object-fit: scale-down;
}

#vessel-position-mode-label {
  margin: 20px;
  list-style: none;
  overflow: hidden;
  li {
    height: 40px;
    width: 100px;
    border-radius: 5px;
    text-align: center;
    background-color: #5097d5;
    p {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: 0 -50% 0 0;
      transform: translate(-50%, -50%);
      color: #ffffff;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
    }
  }
}
#vessel-position-area {
}
#vessel-position-live-camera-are {
  display: grid;
  grid-template-rows: 100px 50px;
  grid-template-columns: 200px 200px;
  #itemA {
    grid-area: areaA;
    background: #f88;
  }
  #itemB {
    grid-area: areaB;
    background: #8f8;
  }
  #itemC {
    grid-area: areaC;
    background: #88f;
  }
}

.live-camera-card {
  border-radius: 0 !important;
  .vx-card {
    border-radius: 0 !important;
  }
}
#player-controller-container {
  position: relative;
}

#timeline-controller-container {
  position: relative;
  background-color: #f2f2f2;
  height: 160px;
}

.map-overlay-container {
  color: black;
  position: absolute;
  width: 38%;
  top: 0;
  left: 0;
  padding: 10px;
  z-index: 1;
}

.map-overlay {
  color: black;
  background-color: #fff;
  border-radius: 3px;
  padding: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.map-overlay h2,
.map-overlay p {
  margin: 0 0 10px;
}

.mapboxgl-canvas {
  position: inherit !important;
}

.map-overlay-container-no-info {
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 5;
  background-color: black;
  border-radius: 3px;
  opacity: 0.8;
  .map-overlay-no-info {
    top: 50%;
    left: 50%;
    color: #fff;
    position: relative;
    p {
      position: absolute;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      height: 100%;
      width: 80%;
      text-align: center; /*一応BOX内の文字も中央寄せ*/
    }
  }
}
.mapboxgl-ctrl-bottom-right .mapboxgl-ctrl {
  margin: 0 10px 40px 0 !important;
}
#vessel-style-change {
  margin-bottom: 10px !important;
}
</style>
